import {cleanNumberFormatter, dateFormatter, integerFormatter, numberFormatter, percentageBarFormatter, shortDateFormatter} from "../../gridFormatters";

export const databaseMissingIndexesDefs = [
    {
        field: "device_name",
        headerName: "Instance Name",
    },
    {
        field: "table_name",
        headerName: "Table Name",
    },
    //The number of user queries (seeks) that could benefit from the missing index.
    {
        field: "user_seeks",
        headerName: "User Seeks",
        cellRenderer: integerFormatter
    },
    //The most recent time a user query (seek) would have benefited from the missing index.
    {
        field: "last_user_seek",
        headerName: "Last User Seek",
        cellRenderer: shortDateFormatter
    },
    //The average estimated cost (in arbitrary units) for queries without the missing index. Higher values indicate greater cost savings.
    {
        field: "avg_total_user_cost",
        headerName: "Improvement Measure",
        type: "numericColumn",
        cellStyle: {
            textAlign: "right"
        },
        aggFunc: "sum",
        filter: "agNumberColumnFilter",
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
        cellRenderer:numberFormatter
    },
    //The estimated percentage improvement in cost for queries with the missing index.
    {
        field: "avg_user_impact",
        headerName: "Impact Percentage (%)",
        cellRenderer: percentageBarFormatter,
        type: "numericColumn",
        cellStyle: {
            textAlign: "right"
        },
        aggFunc: "sum",
        filter: "agNumberColumnFilter",
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
    },
      {
        field: "IncludedColumns",
        headerName: "Included Columns",
    },
      {
        field: "EqualityColumns",
        headerName: "Equality Columns",
    },
    {
        field: "InequalityColumns",
        headerName: "Inequality Columns",
    },
    {
        field: "user_seeks",
        headerName: "# of Queries",
    }
]

export const databaseUnusedIndexesDefs = [
    {
        "field": "device_name",
        "headerName": "Device Name",
    },
    {
        "field": "device_type_code",
        "headerName": "Device Type",
    },
    {
        "field": "last_access_date",
        "headerName": "Last Accessed",
        cellRenderer: dateFormatter
    },
    {
        "field": "index_id",
        "headerName": "Index ID"
    },
    {
        "field": "index_name",
        "headerName": "Index Name",
    },
    {
        "field": "schema_name",
        "headerName": "Schema Name",
    },
    {
        "field": "table_name",
        "headerName": "Table Name",
    }
]